/**
 * Smooth scroll for anchors in single posts
 */
import smooth from "smooth-scroll"

const scroll = new smooth('.lmt__article a[href^="#"]', {
    ignore:'.jet-data-store-link-wrapper a[href^="#"]',
    speed: 1500,
    speedAsDuration: true,
    offset: 250,
});

